export default __webpack_public_path__ + "static/media/3.5b9f0c82.jpg";